var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/email-svgrepo-com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 8C11.1667 9.47273 9.97273 10.6667 8.5 10.6667C7.02724 10.6667 5.83333 9.47273 5.83333 8C5.83333 6.52724 7.02724 5.33333 8.5 5.33333C9.97273 5.33333 11.1667 6.52724 11.1667 8ZM11.1667 8V9C11.1667 9.92047 11.9129 10.6667 12.8333 10.6667C13.7538 10.6667 14.5 9.92047 14.5 9V8C14.5 4.68629 11.8137 2 8.5 2C5.18629 2 2.5 4.68629 2.5 8C2.5 11.3137 5.18629 14 8.5 14H11.1667",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 8C11.1667 9.47273 9.97273 10.6667 8.5 10.6667C7.02724 10.6667 5.83333 9.47273 5.83333 8C5.83333 6.52724 7.02724 5.33333 8.5 5.33333C9.97273 5.33333 11.1667 6.52724 11.1667 8ZM11.1667 8V9C11.1667 9.92047 11.9129 10.6667 12.8333 10.6667C13.7538 10.6667 14.5 9.92047 14.5 9V8C14.5 4.68629 11.8137 2 8.5 2C5.18629 2 2.5 4.68629 2.5 8C2.5 11.3137 5.18629 14 8.5 14H11.1667",
    stroke: "#197A56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.dea72f6d3f8fc65a9ad70f7ac76562b7.svg";
export { ForwardRef as ReactComponent };